export default "__VITE_ASSET__1XiGmDke__"